export default __webpack_public_path__ + "static/media/img1.f785cb3a.png";